import type { LaneletsCenterLinePoints, Lanes } from './types';

export const getLaneletById = (
  laneletsCenterLinePoints: LaneletsCenterLinePoints,
) => {
  const lanes: Lanes = {};
  laneletsCenterLinePoints.lanelets_center_line_points.forEach((data, i) => {
    const prevLaneId =
      laneletsCenterLinePoints.lanelets_center_line_points[i - 1]?.lanelet_id;
    const laneId = data.lanelet_id;
    if (prevLaneId !== laneId) {
      lanes[laneId] = [];
    }
    lanes[laneId].push({
      lat: data.location.lat,
      lng: data.location.lng,
    });
  });
  return lanes;
};
